// removed by extract-text-webpack-plugin
module.exports = {"summary":"app-pages-Customers-CustomerList-ListLoyalty-Summary-__Summary___KRrjI","total":"app-pages-Customers-CustomerList-ListLoyalty-Summary-__Summary___3EfPY","title":"app-pages-Customers-CustomerList-ListLoyalty-Summary-__Summary___2ijQC"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/CustomerList/ListLoyalty/Summary/Summary.css
// module id = 2297
// module chunks = 0